export default "__VITE_ASSET__Cqs2Jj$U__"